import React, { Component } from 'react';

class Progress extends Component {
    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-content-box clearfix" data-margin="0 31px 0 0" data-mobilemargin="0 0 0 0">
                    <p className="font-size-16 no-margin">At K.Lizz Classic Hardware, we pride ourselves on maintaining the highest standards in product quality, customer service, and inventory management to serve Nairobi's construction community.</p>
                    <div className="themesflat-spacer clearfix" data-desktop={37} data-mobile={35} data-smobile={35} />
                    <div className="themesflat-progress style-1 height-10px clearfix">
                        <h3 className="title">PRODUCT QUALITY</h3>
                        <div className="perc-wrap">
                            <div className="perc"><span>95%</span></div>
                        </div>
                        <div className="progress-bg" data-percent={95} data-inviewport="yes">
                            <div className="progress-animate" />
                        </div>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={25} data-mobile={25} data-smobile={25} />
                    <div className="themesflat-progress style-1 height-10px clearfix">
                        <h3 className="title">CUSTOMER SATISFACTION</h3>
                        <div className="perc-wrap">
                            <div className="perc"><span>92%</span></div>
                        </div>
                        <div className="progress-bg" data-percent={92} data-inviewport="yes">
                            <div className="progress-animate" />
                        </div>
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={26} data-mobile={26} data-smobile={26} />
                    <div className="themesflat-progress style-1 height-10px clearfix">
                        <h3 className="title">STOCK AVAILABILITY</h3>
                        <div className="perc-wrap">
                            <div className="perc"><span>88%</span></div>
                        </div>
                        <div className="progress-bg" data-percent={88} data-inviewport="yes">
                            <div className="progress-animate" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Progress;